import { DEFAULT_PAGE_SIZE } from 'config/constants';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { Maybe } from 'graphql/generated';
import { useCurrentPageQuery } from 'helpers/queryParams/useCurrentPageQuery';
import { useEffect, useRef } from 'react';
import { FriendlyUrlPageType } from 'types/friendlyUrl';
import { ListedProductType } from 'types/product';
import { useGtmContext } from 'utils/Gtm/context/GtmProvider';
import { getGtmProductsListEvent, getNewGtmEcommerceEvent } from 'utils/Gtm/EventFactories';
import { getCategoryOrSeoCategoryGtmListName, gtmSafePushEvent } from 'utils/Gtm/Gtm';

export const useGtmCategoryProductListView = (
    data: Maybe<FriendlyUrlPageType> | undefined,
    slug: string,
    products: ListedProductType[],
    fetching: boolean,
): void => {
    const lastViewedCategorySlug = useRef<string | undefined>(undefined);
    const lastViewedCategoryPage = useRef<number | undefined>(undefined);
    const currentPage = useCurrentPageQuery();
    const { url } = useDomainConfig();
    const { didPageViewRun } = useGtmContext();

    useEffect(() => {
        if (
            didPageViewRun &&
            data !== null &&
            data !== undefined &&
            data.__typename === 'Category' &&
            (lastViewedCategorySlug.current !== slug || lastViewedCategoryPage.current !== currentPage) &&
            !fetching &&
            products.length !== 0
        ) {
            lastViewedCategorySlug.current = slug;
            lastViewedCategoryPage.current = currentPage;
            const event = getNewGtmEcommerceEvent('ec.products_list', true);

            event.ecommerce = getGtmProductsListEvent(
                products,
                getCategoryOrSeoCategoryGtmListName(data),
                currentPage,
                DEFAULT_PAGE_SIZE,
                url,
            );
            gtmSafePushEvent(event);
        }
    }, [currentPage, data, fetching, slug, url, products, didPageViewRun]);
};
